<template>
  <section class="hero">
    <div class="sliders">
      <img
          v-for="(image, index) in images"
          :key="index"
          :alt="'hero-' + (index + 1)"
          :class="{ active: currentSlide === index }"
          :src="image"
      />
    </div>
  </section>
</template>

<script>
export default {
  name: "Hero",
  data() {
    return {
      images: [
        require("@/assets/HAIR-SALON-SPa-2.png"),
        require("@/assets/HAIR-SALON-SPa.png"),
        // require("@/assets/HAIR-SALON-SPA-3.png"),
      ],
      currentSlide: 0,
    };
  },
  mounted() {
    this.startSlider();
  },
  methods: {
    startSlider() {
      setInterval(() => {
        this.currentSlide = (this.currentSlide + 1) % this.images.length;
      }, 3000);
    },
  },
};
</script>

<style scoped>
.hero {
  width: 100%;
  overflow: hidden;
  margin-bottom: 40px;
}

.sliders {
  display: flex;
  overflow: hidden;
  position: relative;
  height: 400px;
  width: 100%;
}

.sliders img {
  width: 100%;
  height: 100%;
  transition: opacity 1s ease;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  object-fit: cover;
}

.sliders img.active {
  opacity: 1;
  display: block;
}

/* Responsive height for mobile - đồng bộ với PageHero */
@media (max-width: 768px) {
  .sliders {
    height: 250px;
  }

  .sliders img {
    object-position: calc(50% - 10px) center;
  }
}

/* Thêm vào CSS của Hero component để tránh bị header che */
.hero {
  width: 100%;
  overflow: hidden;
  margin-top: 80px;
}

/* Alternative: Sử dụng CSS variable để flexible hơn */
:root {
  --header-height: 80px;
}

.hero {
  margin-top: var(--header-height);
}

/* Responsive adjustments */
@media (max-width: 992px) {
  :root {
    --header-height: 75px;
  }
}

@media (max-width: 480px) {
  :root {
    --header-height: 70px;
  }
}</style>